import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
} from "@mui/material";
import { useEffect, useState } from "react";
import useFetchDataWithPagination from "../../../utility/useFetchDataWithPagination";
import usePostData from "../../../utility/usePostData";

const DisplayCotisation = () => {
  const [url, setUrl] = useState("cotisation_afiliers");

  const { data, refreshSearch } =
    useFetchDataWithPagination("list_chargements");
  const { submitData } = usePostData(data);

  const [donnes, setDonnes] = useState(null);
  const [cancelling, setCancelling] = useState(null);

  useEffect(() => {
    if (data?.data) {
      setDonnes(data?.data);
    }
  }, [data]);

  const deleteDisplayedElement = async (traitement, table) => {
    const response = window.confirm("êtez-vous sûr ? ");

    if (response) {
      try {
        setCancelling(traitement);
        await submitData(
          "cotisation_annuler/" + traitement + "/" + table,
          {},
          "POST",
        );
        await refreshSearch();
      } catch (e) {
        // ignore - submitData may handle errors
      } finally {
        setCancelling(null);
      }
    }
  };

  const styleP = {
    cursor: "pointer",
    background: "rgba(255,0,0,0.7)",
  };
  const noSelected = {
    cursor: "pointer",
  };
  return (
    <Box sx={{ m: 1, width: "95%", margin: "auto", mt: 3 }}>
      <Paper elevation={2} sx={{ p: 3 }}>
        {!donnes ? (
          <Box sx={{ display: "flex", justifyContent: "center", p: 6 }}>
            <CircularProgress />
          </Box>
        ) : (
          <div className="row">
            <div className="col-md-6">
              <Typography
                variant="h6"
                sx={{
                  color: url === "cotisation_afiliers" ? "#ec1a20" : "#00a652",
                  cursor: "pointer",
                  mb: 2,
                  fontWeight: 500,
                }}
                onClick={() => setUrl("cotisation_afiliers")}
              >
                Cotisation des affiliers
              </Typography>
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow style={{ backgroundColor: "#00a652" }}>
                      <TableCell style={{ color: "white", fontWeight: 500 }}>
                        #
                      </TableCell>
                      <TableCell style={{ color: "white", fontWeight: 500 }}>
                        Code d'activité
                      </TableCell>
                      <TableCell style={{ color: "white", fontWeight: 500 }}>
                        Nombre Total
                      </TableCell>
                      <TableCell style={{ color: "white", fontWeight: 500 }}>
                        Date
                      </TableCell>
                      <TableCell style={{ color: "white", fontWeight: 500 }}>
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {donnes &&
                      donnes.affilies &&
                      donnes.affilies.map((e, i) => (
                        <TableRow key={i} hover>
                          <TableCell>{i + 1}</TableCell>
                          <TableCell>{e.traitement}</TableCell>
                          <TableCell>{e.total_ligne}</TableCell>
                          <TableCell>{e.created_at}</TableCell>
                          <TableCell>
                            <button
                              className="btn btn-sm"
                              style={{
                                backgroundColor: "#ec1a20",
                                color: "white",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                              onClick={() =>
                                deleteDisplayedElement(
                                  e.traitement,
                                  "cotisation_afiliers",
                                )
                              }
                              disabled={Boolean(
                                cancelling && cancelling !== e.traitement,
                              )}
                            >
                              {cancelling === e.traitement ? (
                                <CircularProgress
                                  size={16}
                                  sx={{ color: "white" }}
                                />
                              ) : (
                                "Annuler"
                              )}
                            </button>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>

            <div className="col-md-6">
              <Typography
                variant="h6"
                sx={{
                  color: url === "cotisation_detaches" ? "#ec1a20" : "#00a652",
                  cursor: "pointer",
                  mb: 2,
                  fontWeight: 500,
                }}
                onClick={() => setUrl("cotisation_detaches")}
              >
                Cotisation des detaches
              </Typography>
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow style={{ backgroundColor: "#00a652" }}>
                      <TableCell style={{ color: "white", fontWeight: 500 }}>
                        #
                      </TableCell>
                      <TableCell style={{ color: "white", fontWeight: 500 }}>
                        Activité No
                      </TableCell>
                      <TableCell style={{ color: "white", fontWeight: 500 }}>
                        Nombre Total
                      </TableCell>
                      <TableCell style={{ color: "white", fontWeight: 500 }}>
                        Date
                      </TableCell>
                      <TableCell style={{ color: "white", fontWeight: 500 }}>
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {donnes &&
                      donnes.detaches &&
                      donnes.detaches.map((e, i) => (
                        <TableRow key={i} hover>
                          <TableCell>{i + 1}</TableCell>
                          <TableCell>{e.traitement}</TableCell>
                          <TableCell>{e.total_ligne}</TableCell>
                          <TableCell>{e.created_at}</TableCell>
                          <TableCell>
                            <button
                              className="btn btn-sm"
                              style={{
                                backgroundColor: "#ec1a20",
                                color: "white",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                              onClick={() =>
                                deleteDisplayedElement(
                                  e.traitement,
                                  "cotisation_detaches",
                                )
                              }
                              disabled={Boolean(
                                cancelling && cancelling !== e.traitement,
                              )}
                            >
                              {cancelling === e.traitement ? (
                                <CircularProgress
                                  size={16}
                                  sx={{ color: "white" }}
                                />
                              ) : (
                                "Annuler"
                              )}
                            </button>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        )}
      </Paper>
    </Box>
  );
};

export default DisplayCotisation;
